<template>
    <div class="p-2">
        <div>
            <h1 class="mb-4">{{ $t("navbar.productConversions") }}</h1>
        </div>
        <div>
            <router-link :to="{ name: 'AddProductConversion' }" class="btn btn-primary text-white px-4">{{
                $t("utils.add") }}</router-link>
        </div>
        <div>
            <div>
                <Table endpoint="/product_conversions" ref="table" class="mt-3">
                    <template v-slot:header>
                        <div class="row d-none d-lg-flex">
                            <div class="col-lg-4">{{ $t("products.name") }}</div>
                            <div class="col-lg-2">{{ $t("products.koeficient") }}</div>
                            <div class="col-lg-6"></div>
                        </div>
                    </template>
                    <template #row="line">
                        <div class="row py-2 align-items-start">

                            <!-- Name -->
                            <div class="col-12 col-lg-4">
                                <span>{{ line.item.option_name }}</span>
                            </div>
                            <div class="col-12 col-lg-2">
                                <span>{{ line.item.coeficient }}</span>
                            </div>

                            <!-- Actions -->
                            <div class="col-12 col-lg-6 d-flex flex-wrap justify-content-end gap-3">
                                <button v-if="$store.getters.hasPerm('change_productconversion')"
                                    class="btn btn-sm btn-outline-success" data-bs-toggle="modal"
                                    data-bs-target="#editConversionPopup" @click="editingConversion = line.item">
                                    {{ $t("utils.edit") }}
                                </button>
                                <button v-if="$store.getters.hasPerm('delete_productconversion')"
                                    @click="deleteConversion(line.item.id)" class="btn btn-sm btn-outline-danger">
                                    {{ $t("utils.delete") }}
                                </button>
                            </div>
                        </div>
                    </template>
                </Table>
            </div>
        </div>
    </div>

    <div class="modal fade" tabindex="-1" aria-labelledby="popup" aria-hidden="true" id="editConversionPopup">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="popup">
                        {{ $t("products.editConversion") }}
                    </h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-if="editingConversion">
                    <div>
                        <span>{{ editingConversion.option_name }}</span>
                    </div>
                    <div>
                        <label for="coeficientInput" class="form-label">{{ $t("products.enterCoeficient") }}</label>
                        <input v-model.number="editingConversion.coeficient" type="number" name="coeficient"
                            class="form-control" id="coeficientInput" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-dark" data-bs-dismiss="modal">{{ $t("utils.close") }}</button>
                    <button type="button" class="btn btn-primary text-white" @click="saveConversion">
                        {{ $t("utils.save")}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table,
    },
    data() {
        return {
            conversions: [],
            editingConversion: null,
        }
    },
    methods: {
        deleteConversion(id) {
            this.$store.getters.api.delete("/product_conversions/" + id + "/delete").then((response) => {
                this.$refs.table.loadData();
            })
        },
        saveConversion() {
            this.$store.getters.api.put("/product_conversions/" + this.editingConversion.id + "/edit", {
                coeficient: this.editingConversion.coeficient
            }).then((response) => {
                this.$refs.table.loadData();
            })
        }
    }
}
</script>
<style lang="">

</style>